import { Controller } from "@hotwired/stimulus";

export default class extends Controller<HTMLElement> {
    static targets = ["email", "password", "checkbox", "checkboxContainer", "submit"];

    declare readonly emailTarget: HTMLInputElement;
    declare readonly passwordTarget: HTMLInputElement;
    declare readonly checkboxTarget: HTMLInputElement;
    declare readonly checkboxContainerTarget: HTMLElement;
    declare readonly submitTarget: HTMLButtonElement;
    declare readonly hasEmailTarget: boolean;
    declare readonly hasPasswordTarget: boolean;

    connect(): void {
        this.refreshVisibility();
        this.refreshSubmitState();
    }

    onEmailInput(): void {
        this.refreshVisibility();
        this.refreshSubmitState();
    }

    onCheckboxChange(): void {
        this.refreshSubmitState();
    }

    onPasswordInput(): void {
        this.refreshVisibility();
        this.refreshSubmitState();
    }

    private hasTypedTriggerValue(): boolean {
        if (this.hasPasswordTarget) {
            return this.passwordTarget.value.trim().length > 0;
        }

        if (this.hasEmailTarget) {
            return this.emailTarget.value.trim().length > 0;
        }

        return false;
    }

    private refreshVisibility(): void {
        const visible = this.hasTypedTriggerValue();
        this.checkboxContainerTarget.dataset.signupTermsVisible = visible ? "true" : "false";
        this.checkboxContainerTarget.setAttribute("aria-hidden", visible ? "false" : "true");
        this.checkboxContainerTarget.inert = !visible;
        this.checkboxTarget.disabled = !visible;
    }

    private refreshSubmitState(): void {
        const blocked = this.hasTypedTriggerValue() && !this.checkboxTarget.checked;
        this.submitTarget.disabled = blocked;
        this.submitTarget.setAttribute("aria-disabled", blocked ? "true" : "false");
    }
}
